export class GouvGeorisquesRisqueDto {
  present!: boolean;
  libelle!: string;
  libelleStatutCommune?: string | null;
  libelleStatutAdresse?: string | null;
  specifique?: string | null;
}

export class GouvGeorisquesRisquesNaturelsDto {
  inondation!: GouvGeorisquesRisqueDto;
  remonteeNappe!: GouvGeorisquesRisqueDto;
  risqueCotier!: GouvGeorisquesRisqueDto;
  seisme!: GouvGeorisquesRisqueDto;
  mouvementTerrain!: GouvGeorisquesRisqueDto;
  reculTraitCote!: GouvGeorisquesRisqueDto;
  retraitGonflementArgile!: GouvGeorisquesRisqueDto;
  avalanche!: GouvGeorisquesRisqueDto;
  feuForet!: GouvGeorisquesRisqueDto;
  eruptionVolcanique!: GouvGeorisquesRisqueDto;
  cyclone!: GouvGeorisquesRisqueDto;
  radon!: GouvGeorisquesRisqueDto;
}

export class GouvGeorisquesRisquesTechnologiquesDto {
  icpe!: GouvGeorisquesRisqueDto;
  nucleaire!: GouvGeorisquesRisqueDto;
  canalisationsMatieresDangereuses!: GouvGeorisquesRisqueDto;
  pollutionSols!: GouvGeorisquesRisqueDto;
  ruptureBarrage!: GouvGeorisquesRisqueDto;
  risqueMinier!: GouvGeorisquesRisqueDto;
}

export class GouvGeorisquesDto {
  adresse?: {
    libelle: string;
    longitude: number;
    latitude: number;
  };
  commune?: {
    libelle: string;
    codePostal: string;
    codeInsee: string;
  };
  url?: string;
  risquesNaturels!: GouvGeorisquesRisquesNaturelsDto;
  risquesTechnologiques!: GouvGeorisquesRisquesTechnologiquesDto;
}
